import axiosInstance from "../axios/axios-configuration";
import { CancelToken } from "axios";
import { ICodiceLavorazionePostel, IPrintAndSend, IPrintAndSendRequest } from "../shared/interfaces";

const controller = 'PrintAndSend';

const getPrintAndSendList = (aooId: number, uorId: number, protocolId: number, cancelToken?: CancelToken): Promise<IPrintAndSend[]> => {
    return axiosInstance.get(`${controller}/${aooId}/${uorId}/GetPrintAndSendList/${protocolId}`, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const getCodiciLavorazione = (aooId: number, uorId: number, cancelToken?: CancelToken): Promise<ICodiceLavorazionePostel[]> => {
    return axiosInstance.get(`${controller}/${aooId}/${uorId}/GetCodiciLavorazione`, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const checkStatusMultiplo = (aooId: number, uorId: number, listMPXSetIds: string[], cancelToken?: CancelToken): Promise<string[]> => {
    return axiosInstance.post(`${controller}/${aooId}/${uorId}/CheckStatusMultiplo`, listMPXSetIds, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const send = (aooId: number, uorId: number, workProcessId: string, printAndSendRequest: IPrintAndSendRequest, cancelToken?: CancelToken): Promise<any> => {
    return axiosInstance.post(`${controller}/${aooId}/${uorId}/Send`, printAndSendRequest, { cancelToken: cancelToken, params: { workProcessId } })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

export default {
    getPrintAndSendList,
    getCodiciLavorazione,
    checkStatusMultiplo,
    send,
}

